var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tooltip-info',[_c('span',{attrs:{"slot":"hint"},slot:"hint"},[_vm._v(_vm._s(_vm.$t('adgroup_billing_hint')))])])}
var staticRenderFns = []

export { render, staticRenderFns }